// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__hadpu","productName":"Table_productName__5CjJO"};